var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.583 5.83398L5.41634 5.83398"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4163 14.5833C10.4163 15.7339 11.3491 16.6667 12.4997 16.6667C13.6503 16.6667 14.583 15.7339 14.583 14.5833C14.583 13.4327 13.6503 12.5 12.4997 12.5C11.3491 12.5 10.4163 13.4327 10.4163 14.5833Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25033 5.41732C1.25033 6.56791 2.18307 7.50065 3.33366 7.50065C4.48425 7.50065 5.41699 6.56791 5.41699 5.41732C5.41699 4.26672 4.48425 3.33398 3.33366 3.33398C2.18307 3.33398 1.25033 4.26672 1.25033 5.41732Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41699 5.80971C7.19137 5.80971 8.89307 6.51458 10.1477 7.76925C11.4024 9.02392 12.1073 10.7256 12.1073 12.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 5.41732C14.5833 6.56791 15.5161 7.50065 16.6667 7.50065C17.8173 7.50065 18.75 6.56791 18.75 5.41732C18.75 4.26672 17.8173 3.33398 16.6667 3.33398C15.5161 3.33398 14.5833 4.26672 14.5833 5.41732Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFork);
export default __webpack_public_path__ + "static/media/fork.add4763e.svg";
export { ForwardRef as ReactComponent };